import React, { useState } from 'react';
import { ShieldCheck, BarChart3, Zap, ArrowRight, Lock, Globe, Settings2 } from 'lucide-react';
import './App.css';

function App() {
  const [theme, setTheme] = useState('industrial');

  const themes = [
    { id: 'industrial', name: 'Industrial Trust', dotColor: '#002366' },
    { id: 'cyber', name: 'Cyber-Logic', dotColor: '#66FCF1' },
    { id: 'bauhaus', name: 'Modern Bauhaus', dotColor: '#FF4500' }
  ];

  return (
    <div className={`app-container theme-${theme}`}>
      
      {/* FLOATING THEME SWITCHER */}
      <div className="theme-switcher-widget">
        <div className="switcher-header">
          <Settings2 size={14} />
          <span>Brand Vibe</span>
        </div>
        <div className="switcher-buttons">
          {themes.map((t) => (
            <button 
              key={t.id}
              onClick={() => setTheme(t.id)}
              className={`theme-btn ${theme === t.id ? 'active' : ''}`}
            >
              <span className="color-dot" style={{ backgroundColor: t.dotColor }}></span>
              {t.name}
            </button>
          ))}
        </div>
      </div>

      <nav className="navbar">
        <div className="nav-brand">
          <div className="logo-box">WZ</div>
          <span className="brand-name">WEITZAND</span>
        </div>
        <div className="nav-links">
          <a href="#methodology">Methodology</a>
          <a href="#solutions">Solutions</a>
          <a href="#privacy" className="privacy-link"><Lock size={12} /> GDPR</a>
        </div>
        <button className="nav-cta">FREE AUDIT</button>
      </nav>

      <header className="hero">
        <div className="hero-text">
          <div className="kicker">Strategic AI Integration</div>
          <h1 className="hero-title">Precision <span className="highlight">Intelligence</span> for German Operations.</h1>
          <p className="hero-desc">We automate efficiency audits for the <strong>Mittelstand</strong>. No fees for analysis. Pure data-driven growth.</p>
          <button className="hero-button">
            START FREE ANALYSIS <ArrowRight size={18} className="btn-icon" />
          </button>
        </div>
        <div className="hero-graphic">
          <div className="analysis-card">
            <BarChart3 size={40} className="icon-accent" />
            <h3>Weitzand Report™</h3>
            <div className="stat-row">
              <span>Inefficiency Found:</span>
              <span className="stat-val">-14.2%</span>
            </div>
            <div className="stat-row">
              <span>Potential Lift:</span>
              <span className="stat-val neon">+22.0%</span>
            </div>
          </div>
        </div>
      </header>

      <section className="pillars" id="methodology">
        <div className="pillar-grid">
          <div className="pillar">
            <Zap className="p-icon" />
            <h4>01. Free Audit</h4>
            <p>Scanning your financial and operational DNA at zero cost.</p>
          </div>
          <div className="pillar">
            <ShieldCheck className="p-icon" />
            <h4>02. Insight</h4>
            <p>Technical reporting on specific AI and software ROI.</p>
          </div>
          <div className="pillar">
            <Globe className="p-icon" />
            <h4>03. Execution</h4>
            <p>Implementing precision tools to capture identified gains.</p>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="f-content">
          <div className="f-logo">WEITZAND</div>
          <div className="f-legal">
            <span>Berlin, Germany</span>
            <span>Impressum</span>
            <span>Privacy</span>
          </div>
        </div>
        <div className="f-motto">// Intelligence. Discipline. Results.</div>
      </footer>
    </div>
  );
}

export default App;